import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  iconSmall:{
    width: '15px !important',
    height: '15px !important',
  },

  icon: {   
    backgroundColor: 'white', 
    borderRadius: 2,
    border: '2px solid ' + theme.colors.primary[400],
    width: 20,
    height: 20,
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },

  iconCheckedSmall:{
    width: '15px !important',
    height: '15px !important',
    '&:before': {
      width: '5px !important',
      height: '5px !important',
    },
  },

  iconChecked: {
    '&:before': {
      display: 'block',
      background: theme.colors.primary[400],
      width: 10,
      height: 10,
      marginTop: 3,
      marginLeft: 3,
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: theme.colors.primary[400],
    },
  },
  rootSmall:{
    padding:0
  }
});

const CheckboxUI = (props) => {
    let { classes, small = false, ...other } = props;
    // const classes = this.props;

    return (
        <Checkbox
            className={small && classes.rootSmall}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.iconChecked, small && classes.iconCheckedSmall)}></span>}
            icon={<span className={clsx(classes.icon, small && classes.iconSmall)} />}
            {...other}
        />
    );
}

export default withStyles(styles)(CheckboxUI)